import { render, staticRenderFns } from "./SearchModalResults.vue?vue&type=template&id=46d2e4e3&scoped=true"
import script from "./SearchModalResults.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModalResults.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchModalResults.vue?vue&type=style&index=0&id=46d2e4e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2e4e3",
  null
  
)

export default component.exports